import { gql } from '@apollo/client';

type SpouseLivingStatus = {
  id: string;
  isSameHousehold: boolean;
};

type Profile = {
  id: string;
  spouseLivingStatus: SpouseLivingStatus;
};

export type QueryResult = {
  request: {
    id: string;
    profile: Profile;
  };
};

export const SPOUSE_LIVING_STATUS = gql`
  query spouseLivingStatus {
    request {
      id
      profile {
        id
        spouseLivingStatus {
          id
          isSameHousehold
        }
      }
    }
  }
`;
